import { GlobalStyles, ThemeProvider } from '@mui/material'
import { RecoverKeysModal } from 'components/RecoverKeysModal'
import { MaintenanceModel } from 'components/MaintenanceModel'
import { MandatoryToast } from 'components/MandatoryToast'
import { OpenMyAccountModal } from 'components/OpenMyAccountModal'
import { PageNotFound } from 'components/PageNotFound'
import { StyledToaster } from 'components/StyledToastContainer'
import { WaitingForConfirmationModal } from 'components/WaitingForConfirmationModal'
import { WalletModal } from 'components/WalletModal'
import Web3Provider from 'components/Web3Provider'

import { EARNS_ENABLED, PERP_ENABLED, SHOW_MAINTENANCE_MODEL } from 'config'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { useCurrentTheme } from 'store/settings/hooks'
import { StateUpdater } from 'store/updater'
import { getMuiGlobalStyleOption } from 'styles/MuiGlobalStyle'

import AssetsView from './Assets'
import { ConvertView } from './Convert'
import { Deposit } from './Deposit'
import { DepositMobile } from './Deposit/DepositMobile'
import { FaucetModal } from './Faucet'
import { HistoryView } from './History'
import { MainView } from './Main'
import { PerpView } from './Perp'
import { ContractInformationView } from './Perp/Information'
import { RestrictedView } from './Restricted'
import { RestrictedTermsView } from './Restricted/Terms'
import { Restricted } from './Restricted/restricted'
import { SpotView } from './Spot'
import Withdraw from './Withdraw'
import { Web3StarknetProvider } from '../components/Web3StarknetProvider'
import { DepositPagePath } from '../constants/deposit'
import ErrorBoundary from '../components/ErrorBoundary'
import { ConvertModal } from 'components/ConvertModal'
import { ConvertSuccessTip } from 'components/ConvertModal/successTip'
import AccountStatus from './AccountStatus'
import { RewardsView } from './Rewards'
import { RewardsTradeView } from './Rewards/Trade'
import { RewardsReferView } from './Rewards/Refer'
import { UpdatesView } from './Updates'
import { PortfolioView } from './Portfolio'
import { PortfolioPositionsView } from './Portfolio/Positions'
import { PortfolioOrdersView } from './Portfolio/Orders'
import { V2WithdrawalView } from './V2Withdrawal'
import { V3WithdrawalView } from './V3Withdrawal'

export default function App() {
  const MuiTheme = useCurrentTheme()

  if (SHOW_MAINTENANCE_MODEL) {
    if (window.localStorage.getItem('zkex_debug') === null) {
      return <MaintenanceModel />
    }
  }

  return (
    <Web3Provider>
      <Web3StarknetProvider>
        <StateUpdater />
        <ThemeProvider theme={MuiTheme}>
          <BrowserRouter>
            <GlobalStyles
              styles={(theme) => {
                return getMuiGlobalStyleOption(theme)
              }}
            />

            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<MainView />}>
                  <Route path="" element={<V3WithdrawalView />} />
                  {/* <Route path="trade" element={<SpotView />} />
                  <Route path="trade/:base/:quote" element={<SpotView />} />

                  {PERP_ENABLED ? (
                    <>
                      <Route path="perp" element={<PerpView />} />
                      <Route path="perp/:base/:quote" element={<PerpView />} />
                      <Route
                        path="contract/information"
                        element={<ContractInformationView />}
                      />
                      <Route
                        path="contract/information/:symbol"
                        element={<ContractInformationView />}
                      />
                    </>
                  ) : null}

                  <Route path="portfolio" element={<PortfolioView />}>
                    <Route path="assets" element={<AssetsView />} />
                    <Route
                      path="positions"
                      element={<PortfolioPositionsView />}
                    />
                    <Route path="orders" element={<PortfolioOrdersView />} />
                    <Route path="history" element={<HistoryView />} />
                    <Route path="history/:type" element={<HistoryView />} />
                  </Route> */}

                  <Route path="v2/withdrawal" element={<V2WithdrawalView />} />
                  <Route path="v3/withdrawal" element={<V3WithdrawalView />} />

                  {/* <Route path="convert" element={<ConvertView />} />
                  <Route
                    path="convert/:base/:quote"
                    element={<ConvertView />}
                  />

                  {EARNS_ENABLED && (
                    <Route path="rewards" element={<RewardsView />}>
                      <Route path="trade" element={<RewardsTradeView />} />
                      <Route path="refer" element={<RewardsReferView />} />
                    </Route>
                  )} */}

                  <Route path="restricted" element={<RestrictedView />}>
                    <Route path="" element={<Restricted />} />
                    <Route path="terms" element={<RestrictedTermsView />} />
                  </Route>

                  <Route path="updates" element={<UpdatesView />} />
                </Route>
                <Route path="og" element={<AccountStatus />} />
                <Route path={DepositPagePath} element={<DepositMobile />} />
                <Route path="*" element={<PageNotFound error={404} />} />
              </Routes>
            </ErrorBoundary>
            <FaucetModal />
            <Deposit />
            <Withdraw />
            <RecoverKeysModal />
            <WalletModal />
            <MandatoryToast />
            <OpenMyAccountModal />
            <WaitingForConfirmationModal />
            <StyledToaster />
            <ConvertModal />
            <ConvertSuccessTip />
          </BrowserRouter>
        </ThemeProvider>
      </Web3StarknetProvider>
    </Web3Provider>
  )
}
